import { ThemeId } from "../../../../../../../styles/types/theme.js";
import veciPersonCounterStyles from "./styles/veci.js";
const personCounterThemes = {
    [ThemeId.veci]: veciPersonCounterStyles
};
export default personCounterThemes;

//# sourceMappingURL=index.js.map